import { UniNotice } from 'api/uninotice/UniNotice'
import { newMessageNoticeId } from 'components/uninotice/uniNoticeIdList'

export const isNoticeNewMessage = (uniNotice: UniNotice) =>
  uniNotice.noticeId?.includes(newMessageNoticeId)
